import { RestServiceBase } from '../RestServiceBase';
import { MoveActivityRequest } from './requests/MoveActivityRequest';
import { MoveActivityResponse } from './responses/MoveActivityResponse';
import { MoveProjectRequest } from './requests/MoveProjectRequest';
import { MoveProjectResponse } from './responses/MoveProjectResponse';

export interface IStewardRestService {
    moveActivity(request: MoveActivityRequest): Promise<MoveActivityResponse>;
    moveProject(request: MoveProjectRequest): Promise<MoveProjectResponse>;
}

export class StewardRestService extends RestServiceBase implements IStewardRestService {
    public async moveActivity(request: MoveActivityRequest): Promise<MoveActivityResponse> {
        const CALL_TAG = `move_activity?${request.toQueryString()}`;
        let response: any = null;
    
        try {
          let tmp_response = await this.makeCall(null, CALL_TAG, request.cancelSource);
          response = tmp_response.data;
          await this.updateCache(CALL_TAG, request.toQueryString(), response);
        } catch (error: any) {
          response = await this.getFromCache(CALL_TAG, request.toQueryString());
        }
        var parsedResponse = response as MoveActivityResponse;
        return parsedResponse;
    }

    public async moveProject(request: MoveProjectRequest): Promise<MoveProjectResponse> {
        const CALL_TAG = `move_project?${request.toQueryString()}`;
        let response: any = null;
        try {
            let tmp_response = await this.makeCall(null, CALL_TAG, request.cancelSource);
            response = tmp_response.data;
            await this.updateCache(CALL_TAG, request.toQueryString(), response);
        } catch (error: any) {
            response = await this.getFromCache(CALL_TAG, request.toQueryString());
        }
        var parsedResponse = response as MoveProjectResponse;
        return parsedResponse;
    }
}
